import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';

@Component({
    selector: 'diagnosis-search',
    templateUrl: './diagnosis-search.component.html',
    styleUrls: ['./diagnosis-search.component.scss'],
    standalone: false
})
export class DiagnosisSearchComponent {
  @Input() set searchData(value: string) {
    this.form.get('searchControl')?.setValue(value);
  };

  @Input() set isInterruption(value: boolean) {
    if (value) {
      this.form?.get('searchControl')?.disable({ emitEvent: false });
    }
  };

  @Output() searchDataChange = new EventEmitter<string>();

  form = new FormGroup({
    searchControl: new FormControl({value: null, disabled: this.isInterruption}, [Validators.required, Validators.minLength(3), Validators.maxLength(10)])
  })

  searchICD() {
    this.searchDataChange.emit(this.form.get('searchControl').value);
  }
}
